export const resetQualityValue = (model, characterKey, qualityKey) => {
  model.character(characterKey).setQuality(qualityKey, model.character(characterKey).getQualityInitial(qualityKey))
}

export const resetAll = model => {
  resetQualityValue(model, 'me', 'gender')
  resetQualityValue(model, 'me', 'firstname')
  resetQualityValue(model, 'me', 'mood')
  resetQualityValue(model, 'manager', 'mood')
}

export const isWoman = model => model.character('me').getQuality('gender') === 'femme'

export default {
  resetQualityValue,
  resetAll,
  isWoman,
}
